import React from "react";
import { X, Download, FileText, Loader2 } from "lucide-react";
import { PDFViewer, PDFDownloadLink } from "@react-pdf/renderer";
import { QuotationPDFDocument } from "./QuotationPDFDocument";

export function QuotationPDFPreviewModal({
    open,
    onClose,
    quotation,
    client,
    customCharges,
    organization
}) {
    if (!open) return null;
    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4 md:p-8 animate-in fade-in duration-200">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-5xl h-[90vh] flex flex-col overflow-hidden animate-in zoom-in-95 duration-200">
                {/* Modal Header */}
                <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 bg-white">
                    <div className="flex items-center gap-4">
                        <div className="bg-sm-primary/10 p-2.5 rounded-xl">
                            <FileText className="h-6 w-6 text-sm-primary" />
                        </div>
                        <div>
                            <h2 className="text-xl font-bold text-gray-900 tracking-tight">Quotation Preview</h2>
                            <p className="text-sm text-gray-500 font-medium">Review details before downloading</p>
                        </div>
                    </div>
                    <div className="flex items-center gap-4">
                        <PDFDownloadLink
                            document={
                                <QuotationPDFDocument
                                    quotation={quotation}
                                    client={client}
                                    organization={organization}
                                    customCharges={customCharges}
                                />
                            }
                            fileName={`Quotation_${quotation?.id || "preview"}.pdf`}
                        >
                            {({ loading }) => (
                                <button
                                    disabled={loading}
                                    className="inline-flex items-center gap-2 px-6 py-2.5 bg-sm-primary text-white rounded-md text-sm font-semibold hover:bg-sm-primary/90 transition-all shadow-sm hover:shadow-md disabled:opacity-50 ring-offset-2 hover:ring-2 hover:ring-sm-primary/20"
                                >
                                    {loading ? (
                                        <>
                                            <Loader2 className="h-4 w-4 animate-spin" />
                                            Preparing Download...
                                        </>
                                    ) : (
                                        <>
                                            <Download className="h-4 w-4" />
                                            Download PDF
                                        </>
                                    )}
                                </button>
                            )}
                        </PDFDownloadLink>
                        <button
                            onClick={onClose}
                            className="p-2.5 hover:bg-gray-100 rounded-xl transition-all text-gray-400 hover:text-gray-600 border border-transparent hover:border-gray-200"
                        >
                            <X className="h-6 w-6" />
                        </button>
                    </div>
                </div>

                {/* Modal Content - PDF Viewer */}
                <div className="flex-1 bg-[#F8FAFC] p-4 md:p-6 overflow-hidden relative">
                    <div className="w-full h-full bg-white rounded-xl shadow-inner border border-gray-200/60 overflow-hidden">
                        <PDFViewer className="w-full h-full border-none">
                            <QuotationPDFDocument
                                quotation={quotation}
                                client={client}
                                organization={organization}
                                customCharges={customCharges}
                            />
                        </PDFViewer>
                    </div>
                </div>



            </div>
        </div>
    );
}
